module.exports = __webpack_public_path__ + "static/img/G6_V3.cb9c669.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/captation/img/G6_V3.png
// module id = xLQB
// module chunks = 1